import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const ImportStatusSelect = (props) => {
    return (
        <InputGroup>
            <Form.Select size={props.size} value={props.value ?? null} onChange={props.onChange}>
                <option value="">ทั้งหมด</option>
                <option value="0">ไม่สำเร็จ</option>
                <option value="1">สำเร็จ</option>
                <option value="2">ไม่มีการดำเนินการ</option>
                <option value="3">อัพเดทข้อมูล</option>
            </Form.Select>
        </InputGroup>
    );
};

export default ImportStatusSelect;
